export * from './services/vendas-core-bff-service'
